<script setup lang="ts">

import {computed, HTMLAttributes} from 'vue'
import {FormControl, FormDescription, FormItem, FormLabel, FormMessage} from "@/shared/components/ui/form2/";
import {FormItemProps} from ".";
import {gridItemVariants} from "@/shared/components/ui/helper/";
import {cn} from "@/shared/lib/utils.ts";
import FormError from "@/shared/components/ui/form2/FormError.vue";
import {Checkbox} from "@/shared/components/ui/checkbox";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {HStack} from "@/shared/components/ui/helper";

interface FormCheckboxProps extends FormItemProps {
  icon?: IconDefinition
  iconClass?: HTMLAttributes['class'],
}

const props = withDefaults(defineProps<FormCheckboxProps>(), {
  required: false,
});
const modelValue = defineModel<boolean>()

defineSlots<{
  prepend?: (props: {}) => any
  append?: (props: {}) => any
}>()

const hasError = computed(() => props.error != undefined)

const handleChange = (value: boolean) => {
  modelValue.value = value
}
</script>

<template>
  <FormItem :class="cn(gridItemVariants({ colSpan }), 'form-input', props.class)">
    <FormControl>
      <FormItem>
        <FormLabel :error="hasError" class="font-normal flex flex-row items-center space-x-2 space-y-0">
          <FormControl>
            <Checkbox :checked="modelValue" :class="[props.elementClass, { 'border-red-600': hasError }]" @update:checked="handleChange"/>
          </FormControl>
          <HStack align="center" class="gap-x-1.5">
            <FontAwesomeIcon :icon="icon" :class="props.iconClass" title="Mijn klant"/>
            <span>{{ label }}</span>
          </HStack>
        </FormLabel>
      </FormItem>
      <FormError :error="error"/>
    </FormControl>
    <FormDescription v-if="description" v-html="description"/>
    <FormMessage/>
  </FormItem>
</template>

<style scoped>

</style>